// Charge report monthly
import { API_BASE } from "../../config";
import { useEffect, useState } from "react";
import MonthlyBarChart from "../../components/Air/DBLKByMonth/BarCard"
import DataSelector from "../../components/Air/DBLKByMonth/DataSelector";
import AdminLayout from "../../layout/AdminLayout"
import axios from "axios";

const DBLKByMonth = () =>{

    const [data,setData] = useState(null)
 
    const handleData = async () =>{
        try {
            const res = await axios.get(`${API_BASE}/api/air-client/month/current`)
             setData(res.data.clients);
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(()=>{
        handleData();
    },[])

    return(
        <AdminLayout>
                 <div className="my-5 flex justify-center items-center">
                   {data &&   <MonthlyBarChart data={data}/>}
                 </div>
                 <div>
                     {data && <DataSelector data={data}/>}
                 </div>
        </AdminLayout>
    );
}
export default DBLKByMonth;
